import React from "react";

const PlayBig = () => {
  return (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.67 24.9023L18.0028 39.6187C17.5315 40.1271 16.8011 40.1271 16.3298 39.6187C16.1177 39.39 15.9763 39.0596 15.9763 38.7291V9.27085C15.9999 8.55917 16.5183 8 17.1781 8C17.4844 8 17.7908 8.12709 18.0028 8.38125L31.6464 23.0977C32.1177 23.606 32.1177 24.394 31.6464 24.9023H31.67Z" fill="currentColor" />
  </svg>
  )
}

export default PlayBig;
